<!--
 * @Author: your name
 * @Date: 2021-12-28 11:50:39
 * @LastEditTime: 2021-12-28 17:33:25
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \icps_pcweb\src\views\platform\ICPS\smart\materialcheckout\components\CementMortarDialog.vue
-->
<template>
  <el-dialog v-dialogDrag :title="config.type === 'add' ? '添加' : '查看'" :visible.sync="visible" width="700px" :close-on-click-modal="false" @close="onClose" @open="onOpen">
    <div class="dialog_box">
      <el-form ref="form" label-width="100px">
        <el-form-item label="站点">
          <span slot="label" class="require">站点</span>
          <el-select v-model="station" value-key="id" placeholder="请选择" :disabled="config.type === 'examine'">
            <el-option v-for="item in siteIdList" :key="item.id" :value="item" :label="item.name" />
          </el-select>
        </el-form-item>
        <el-form-item label="编号">
          <span slot="label" class="require">编号</span>
          <el-input v-model="code" v-input-limit="/^((?![A-Za-z0-9]+$).)*/g" placeholder="请输入" style="width: 215px" :disabled="config.type === 'examine'" />
        </el-form-item>
        <el-form-item label="基准流动度">
          <span slot="label" class="require">基准流动度</span>
          <el-input v-model="referenceMobility" v-input-limit="value => this.inputReg(value)" placeholder="请输入" style="width: 215px" :disabled="config.type === 'examine'" />
        </el-form-item>
      </el-form>

      <table border="1" cellpadding="0" cellspacing="0" class="cementMortar_dialog_table">
        <tr>
          <td>实验龄期</td>
          <td colspan="2">7天</td>
          <td colspan="2">28天</td>
        </tr>
        <tr>
          <td>强度项目</td>
          <td>检测值</td>
          <td>平均值</td>
          <td>检测值</td>
          <td>平均值</td>
        </tr>
        <tr>
          <td rowspan="6">基准强度</td>
          <td>
            <el-input v-model="jzqd7[0]" v-input-limit="value => this.inputReg(value)" placeholder="请输入" :disabled="config.type === 'examine'" />
          </td>
          <td rowspan="6">
            <span v-if="mean7">{{ mean7 }}</span>
            <span v-else class="require">自动计算</span>
          </td>
          <td>
            <el-input v-model="jzqd28[0]" v-input-limit="value => this.inputReg(value)" placeholder="请输入" :disabled="config.type === 'examine'" />
          </td>
          <td rowspan="6">
            <span v-if="mean7">{{ mean28 }}</span>
            <span v-else class="require">自动计算</span>
          </td>
        </tr>
        <tr>
          <td><el-input v-model="jzqd7[1]" v-input-limit="value => this.inputReg(value)" placeholder="请输入" :disabled="config.type === 'examine'" /></td>
          <td><el-input v-model="jzqd28[1]" v-input-limit="value => this.inputReg(value)" placeholder="请输入" :disabled="config.type === 'examine'" /></td>
        </tr>
        <tr>
          <td><el-input v-model="jzqd7[2]" v-input-limit="value => this.inputReg(value)" placeholder="请输入" :disabled="config.type === 'examine'" /></td>
          <td><el-input v-model="jzqd28[2]" v-input-limit="value => this.inputReg(value)" placeholder="请输入" :disabled="config.type === 'examine'" /></td>
        </tr>
        <tr>
          <td><el-input v-model="jzqd7[3]" v-input-limit="value => this.inputReg(value)" placeholder="请输入" :disabled="config.type === 'examine'" /></td>
          <td><el-input v-model="jzqd28[3]" v-input-limit="value => this.inputReg(value)" placeholder="请输入" :disabled="config.type === 'examine'" /></td>
        </tr>
        <tr>
          <td><el-input v-model="jzqd7[4]" v-input-limit="value => this.inputReg(value)" placeholder="请输入" :disabled="config.type === 'examine'" /></td>
          <td><el-input v-model="jzqd28[4]" v-input-limit="value => this.inputReg(value)" placeholder="请输入" :disabled="config.type === 'examine'" /></td>
        </tr>
        <tr>
          <td><el-input v-model="jzqd7[5]" v-input-limit="value => this.inputReg(value)" placeholder="请输入" :disabled="config.type === 'examine'" /></td>
          <td><el-input v-model="jzqd28[5]" v-input-limit="value => this.inputReg(value)" placeholder="请输入" :disabled="config.type === 'examine'" /></td>
        </tr>
      </table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="bottom_all_two" @click="onClose">取 消</el-button>
      <el-button class="bottom_all" @click="onConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { getStationByCompanyId } from "@/api/common.js";
import { saveStrength } from "@/api/cementMortar";
export default {
  props: {
    config: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      station: {}, // 所选站点数据
      code: "", // 编号
      referenceMobility: "", // 基准流动度
      jzqd7: [], // 7天基准强度
      jzqd28: [], // 28天基准强度
      siteIdList: [], // 站点下拉数据
    };
  },
  computed: {
    mean7() {
      const [n0, n1, n2, n3, n4, n5] = this.jzqd7;
      if (n0 && n1 && n2 && n3 && n4 && n5) {
        const arr = this.jzqd7.map(item => Number(item) || 0);
        const [m0, m1, m2, m3, m4, m5] = arr;
        // return Number(((m0 + m1 + m2 + m3 + m4 + m5) / 6).toFixed(2) || '')
        return ((m0 + m1 + m2 + m3 + m4 + m5) / 6).toFixed(1) || "";
      }
      return "";
    },
    mean28() {
      const [n0, n1, n2, n3, n4, n5] = this.jzqd28;
      if (n0 && n1 && n2 && n3 && n4 && n5) {
        const arr = this.jzqd28.map(item => Number(item) || 0);
        const [m0, m1, m2, m3, m4, m5] = arr;
        // return Number(((m0 + m1 + m2 + m3 + m4 + m5) / 6).toFixed(2) || '')
        return ((m0 + m1 + m2 + m3 + m4 + m5) / 6).toFixed(1) || "";
      }
      return "";
    },
  },
  methods: {
    // 输入框格式校验
    inputReg(value) {
      return String(value || "").match(/\d{1,6}(\.\d{1,2}|\.)?/) ? String(value || "").match(/\d{1,6}(\.\d{1,2}|\.)?/)[0] : "";
    },
    // 校验
    verify() {
      const { station, code, referenceMobility, mean7, mean28 } = this;
      console.log(station, code, referenceMobility, mean7, mean28);
      if (!station.id || !code || !referenceMobility || !mean7 || !mean28) {
        return false;
      }
      return true;
    },
    // 打开弹框
    async onOpen() {
      const companyId = JSON.parse(window.localStorage.getItem("userInfo")).companyId;
      getStationByCompanyId({ id: companyId }).then(res => {
        this.siteIdList = res.data.map(res => ({ name: res.stationName, id: res.id }));
      });
      this.station = this.config.type === "examine" ? { id: this.config.data.stationId, name: this.config.data.stationName } : {};
      this.code = this.config.type === "examine" ? this.config.data.code : "";
      this.referenceMobility = this.config.type === "examine" ? this.config.data.referenceMobility : "";
      this.jzqd7 = this.config.type === "examine" ? JSON.parse(this.config.data.sevenDayValue) : [];
      this.jzqd28 = this.config.type === "examine" ? JSON.parse(this.config.data.twentyEightDayValue) : [];
    },
    // 关闭弹框
    onClose() {
      this.$emit("update:visible", false);
    },
    // 确定
    onConfirm() {
      if (!this.verify()) {
        this.$message.info("请录入必须数据");
        return false;
      }
      const { station, code, referenceMobility, jzqd7, mean7, jzqd28, mean28 } = this;
      const params = {
        stationId: station.id,
        stationName: station.name,
        code,
        referenceMobility,
        sevenDayValue: JSON.stringify(jzqd7),
        sevenDayAvg: mean7,
        twentyEightDayValue: JSON.stringify(jzqd28),
        twentyEightDayAvg: mean28,
      };
      saveStrength(params).then(res => {
        if (res && res.code === 1001) {
          this.$message.success("保存成功");
          this.$emit("updated", false);
          this.$emit("update:visible", false);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
table {
  border-collapse: collapse;
  border: 0 !important;
  width: 100%;
}
td {
  position: relative;
  width: 120px;
  height: 36px;
  text-align: center;
}
table,
th,
td {
  border: 1px solid black;
}
.require {
  color: #ff0000;
}
</style>
